export enum funderTypes {
  INDIVIDUAL_FUNDER = "individual_funder",
  CORPORATE_FUNDER = "corporate_funder",
}
